import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import React, { Component } from 'react'
import {
    getBoardsData,
    getBranchesLatest
} from '../../../../../store/actions';
import { connect } from 'react-redux';
import { baseUrlForLongRunningTask } from '../../../../../store/apiConstants';
import Service from '../../../../services';
import { InputText } from 'primereact/inputtext';
import * as XLSX from 'xlsx';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import LoadingComponent from '../../../../loadingComponent';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import './offlineResultUpload.scss';
import { userAssignedBoards } from '../../../../../store/selectors/userAssignedBoards';

const SheetJSFT = ['xlsx', 'xlsb', 'xlsm', 'xls', 'csv']
    .map(function (x) {
        return '.' + x;
    })
    .join(',');

/* generate an array of column objects */
const make_cols = (refstr) => {
    let o = [],
        C = XLSX.utils.decode_range(refstr).e.c + 1;
    for (var i = 0; i < C; ++i) o[i] = { name: XLSX.utils.encode_col(i), key: i };
    return o;
};

class OfflineResultUpload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTab: 1,
            examId: null,
            sectionIds: [],
            data: [],
            isLoading: false,
            isUploading: false,
            // Add these new state properties like adhocExamResultUpload
            selectedBranchId: null,
            sections: [], // Available sections for selected branch
            availableBranches: [], // Branches filtered by board and class
            selectedClass: null, // Store selected class data
            boardId: props.rowDetailsOfUploading?.boardId,
            classId: props.rowDetailsOfUploading?.classId,
        }
        this.fileUploadRef = React.createRef();
        this.dialogRef = React.createRef();
        this.service = new Service()
    }

    componentDidMount() {
        if (!this.props.branchData) {
            this.props.getBranchesLatest();
        } else {
            this.initializeDropdowns();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.branchData !== this.props.branchData) {
            this.initializeDropdowns();
        }
    }

    // Add these new methods from adhocExamResultUpload
    initializeDropdowns = () => {
        const { boardId, classId } = this.state;
        const { branchData } = this.props;

        if (!branchData || !boardId || !classId) return;

        const selectedBoard = this.props.boards.find(
            (board) => board?.boardId === boardId
        );

        if (selectedBoard) {
            const selectedClass = selectedBoard.classes.find(
                (classd) => classd.classId === classId
            );

            // Store selected class and its branches
            if (selectedClass?.branches?.length) {
                this.setState({
                    availableBranches: selectedClass.branches,
                    selectedClass: selectedClass // Store full class data
                });
            }
        }
    };

    onChangeBranch = (branchId) => {
        const { selectedClass } = this.state;

        // Get sections for this branch from selected class
        const sections = selectedClass?.sections?.filter(
            section => section.branchId === branchId
        ) || [];

        this.setState({
            selectedBranchId: branchId,
            sections: sections,
            sectionIds: [] // Reset section selection when branch changes
        });
    };

    onMultiChange = (value) => {
        this.setState({
            sectionIds: value
        });
    }

    exportCSVV = (items) => {
        this.dt.exportCSV();
    }

    downloadSheet = () => {
        if (this.state.sectionIds && this.state.sectionIds.length) {
            this.setState({ isLoading: true })

            let thisObj = this;
            const url = `${baseUrlForLongRunningTask}/examination/download-assigned-users`;
            this.service.post(url, { examId: this.props.rowDetailsOfUploading.examId, sectionIds: this.state.sectionIds }, true).then(res => {
                if (res && res.status) {
                    if (res?.res?.data?.length) {
                        thisObj.setState({
                            isLoading: false,
                            data: res.res.data
                        }, () => {
                            thisObj.exportCSVV(res.res.data)
                        });
                        thisObj.toast.show({ severity: 'success', summary: 'Success', detail: 'Exam assigned users found, please fill the sheet and upload.', life: 3000 });
                    } else {
                        thisObj.setState({
                            isLoading: false
                        })
                        thisObj.toast.show({ severity: 'error', summary: 'No users', detail: 'Exam is not assigned to any users in the selected sections', life: 3000 });
                    }
                } else {
                    thisObj.setState({
                        isLoading: false
                    }, () => {
                        thisObj.toast.show({ severity: 'error', summary: 'Some error occured', detail: res.errMessage, life: 3000 });
                    });
                }
            }).catch(e => {
                this.setState({ isLoading: false });
                this.toast.show({ severity: 'error', summary: 'Error', detail: 'Some error occured', life: 3000 });
                console.log(e);
            })
        } else {
            this.toast.show({ severity: 'error', summary: 'Invalid', detail: 'Select Section Ids', life: 3000 });
        }
    }

    handleFile = (file) => {
        const reader = new FileReader();
        const rABS = !!reader.readAsBinaryString;
        let data = [];
        reader.onload = (e) => {
            const bstr = e.target.result;
            const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array' });
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            data = XLSX.utils.sheet_to_json(ws, { raw: false });
            this.setState({ data: data, cols: make_cols(ws['!ref']) });

            const newJsonSheet = [];
            for (let i = 0; i < data.length; i++) {
                let excelRowData = {
                    ...data[i],
                    __rowNum__: undefined
                };

                excelRowData = JSON.parse(JSON.stringify(excelRowData));
                newJsonSheet.push(excelRowData);
            }
            this.setState({ users: newJsonSheet });
        };
        if (rABS) reader.readAsBinaryString(file);
        else reader.readAsArrayBuffer(file);
    };

    handleChange = (e) => {
        const files = e.target.files;
        if (files && files[0]) {
            this.setState({ fileSelected: files[0]['name'] });
            this.handleFile(files[0]);
            e.target.value = null;
        }
    };

    changeTab = (tab) => {
        this.setState({
            selectedTab: tab,
        });
    }

    uploadExamResults = async () => {
        if (this.state.users && this.state.users.length) {
            this.setState({
                isLoading: true,
                isUploading: true
            });

            try {
                const url = `${baseUrlForLongRunningTask}/examination/upload-offline-results`;
                const res = await this.service.post(url, { users: this.state.users }, true);

                if (res && res.status) {
                    this.setState({
                        isLoading: false,
                        isUploading: false,
                        users: [],
                        data: []
                    });
                    if (this.fileUploadRef.current) {
                        this.fileUploadRef.current.value = null;
                    }
                    this.toast.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Results uploaded successfully.',
                        life: 3000
                    });
                    // Delay closing dialog to allow toast to be visible
                    setTimeout(() => {
                        this.props.onCancel();
                    }, 500);
                } else {
                    this.setState({
                        isLoading: false,
                        isUploading: false
                    });
                    this.toast.show({
                        severity: 'error',
                        summary: 'Some error occured',
                        detail: res.errMessage,
                        life: 3000
                    });
                }
            } catch (e) {
                this.setState({
                    isLoading: false,
                    isUploading: false
                });
                this.toast.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Some error occured',
                    life: 3000
                });
                console.log(e);
            }
        } else {
            this.toast.show({
                severity: 'error',
                summary: 'Invalid',
                detail: 'Please upload users',
                life: 3000
            });
        }
    }

    render() {
        const { selectedTab } = this.state
        return (
            <>
                <Dialog
                    ref={this.dialogRef}
                    blockScroll={true}
                    style={{ width: '80%', height: '90vh', zIndex: 1000 }}
                    header="Upload Offline Exam Results"
                    modal
                    draggable={false}
                    onHide={this.props.onCancel}
                    closeOnEscape={false}
                    dismissableMask={false}
                    visible={true}
                    closable={true}
                    className="offline-exam-upload"
                >
                    <div className="exam-tabs">
                        <div
                            className={`tab-item ${selectedTab === 1 ? 'active' : ''}`}
                            onClick={() => this.changeTab(1)}
                        >
                            Download Students
                        </div>
                        <div
                            className={`tab-item ${selectedTab === 2 ? 'active' : ''}`}
                            onClick={() => this.changeTab(2)}
                        >
                            Upload Results
                        </div>
                    </div>

                    {selectedTab === 1 && (
                        <div className="download-section">
                            <h3 className="exam-name">{this.props.rowDetailsOfUploading?.examName}</h3>
                            <div className="exam-details">
                                <p><strong>Board:</strong> <span className="highlight-text">{this.props.rowDetailsOfUploading?.boardName}</span></p>
                                <p><strong>Grade:</strong> <span className="highlight-text">{this.props.rowDetailsOfUploading?.className}</span></p>
                            </div>

                            <div className="dropdowns-container">
                                <Dropdown
                                    className="ma-mr20 ma-mt10 ma-w200"
                                    value={this.state.selectedBranchId}
                                    optionLabel="branchName"
                                    optionValue="branchId"
                                    options={this.state.availableBranches}
                                    onChange={(e) => this.onChangeBranch(e.value)}
                                    placeholder="Select Branch"
                                />
                                <MultiSelect
                                    className="ma-m-lr10 ma-w200"
                                    value={this.state.sectionIds}
                                    onChange={(e) => this.onMultiChange(e.value)}
                                    options={this.state.sections}
                                    optionLabel="sectionName"
                                    optionValue="sectionId"
                                    placeholder="Select Sections"
                                    disabled={!this.state.selectedBranchId}
                                />
                            </div>

                            <Button
                                label="Download Sheet"
                                icon="pi pi-download"
                                className="p-button-primary"
                                onClick={this.downloadSheet}
                                disabled={!this.state.sectionIds.length}
                            />
                        </div>
                    )}

                    {selectedTab === 2 && (
                        <div className="upload-section">
                            <p className="spread-title">Users Spreadsheet</p>
                            <div className="file-upload-container">
                                <InputText
                                    value={this.state.fileSelected || ''}
                                    placeholder="No file selected"
                                    disabled
                                />
                                <label htmlFor="file" className="select-file">Select File</label>
                                <input
                                    type="file"
                                    className="form-control"
                                    id="file"
                                    hidden={true}
                                    accept={SheetJSFT}
                                    ref={this.fileUploadRef}
                                    onChange={this.handleChange}
                                />
                                <div className="note-container">
                                    <label className="p-error">
                                        Note : <span style={{ color: "black" }}>Please upload xlsx file format</span>
                                    </label>
                                </div>
                            </div>
                            <Button
                                label="Upload Results"
                                className="upload-button p-button-primary"
                                icon="pi pi-cloud-upload"
                                onClick={this.uploadExamResults}
                                disabled={!this.state.users?.length || this.state.isUploading}
                                loading={this.state.isUploading}
                            />
                        </div>
                    )}
                    <Toast ref={(el) => this.toast = el} position="bottom-right" />
                </Dialog>

                <DataTable ref={(el) => this.dt = el} value={this.state.data} style={{ display: "none" }}>
                    {
                        this.state.data && this.state.data.length ? Object.keys(this.state.data[0]).map((item, index) => {
                            return <Column key={index} field={item} header={item} />
                        }) : null
                    }
                </DataTable>

                {(this.state.isLoading || this.props.isLoading) && <LoadingComponent />}
            </>
        )
    }
}

// Update mapStateToProps to include boards like adhocExamResultUpload
const mapStateToProps = (state) => ({
    boards: userAssignedBoards(state, 'activeBoardsWithoutMeluha'), // Add this line
    isLoading: state.boardsData.loading,
    branches: state.branchDataLatest.branches,
    isBranchLoading: state.branchDataLatest.isLoading,
    branchLevels: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data.levels,
    branchData: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data.data,
});

export default connect(mapStateToProps, { getBranchesLatest, getBoardsData })(OfflineResultUpload)
